// extracted by mini-css-extract-plugin
export var container = "_fz-0";
export var icon = "_fz-1";
export var text = "_fz-2";